module.exports = __webpack_public_path__ + "media/images/no-data-found-74999d5b.png";